/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { Action } from '../redux';
import { DocumentsAPI } from '../api/common/documents';
import { CommonAPI } from '../api/common/responses';
import { SigningActionType } from '@shared/constants/signing';

export const signingRoomReducerInitialState = {
  isExitModalOpen: false,
  signingAction: {
    type: SigningActionType.WAIT_FOR_SIGNING_TO_START,
  } as DocumentsAPI.ActionResponse,
  users: {
    inVideoCall: [],
    onboarding: [],
    missing: [],
  } as CommonAPI.UserDataResponse,
};

export function signingRoomReducer(state = signingRoomReducerInitialState, action: Action) {
  switch (action.type) {
    case 'UPDATE_EXIT_MODAL_STATE':
      return {
        ...state,
        isExitModalOpen: action.payload,
      };
    case 'SET_SIGNING_ACTION':
      const newState = {
        ...state,
        signingAction: {
          ...state.signingAction,
          ...action.payload,
        },
      };
      // Explicitly remove the active document and signer if signing was just turned off
      if (newState.signingAction.type === SigningActionType.WAIT_FOR_SIGNING_TO_START) {
        delete newState.signingAction.document;
        delete newState.signingAction.signerName;
      }
      return newState;
    case 'SET_USERS':
      return {
        ...state,
        users: { ...state.users, ...action.payload },
      };
    case 'SET_SELECTED_NAVIGATION_ITEM_ID':
      return {
        ...state,
        selectedNavigationItemId: action.payload,
      };
    default:
      return state;
  }
}
